import axios from "axios";
import { API } from "../App";
import { translations } from "./i18n";
import { modulesFR } from "../data/psychoeducation-fr";
import { modulesEN } from "../data/psychoeducation-en";
import { modulesES } from "../data/psychoeducation-es";
import { modulesCA } from "../data/psychoeducation-ca";
import { modulesIT } from "../data/psychoeducation-it";
import { modulesPT } from "../data/psychoeducation-pt";
import { modulesNL } from "../data/psychoeducation-nl";
import { getPsychoeducationModules } from "./psychoeducationData";

const TRANSLATED = { en: modulesEN, es: modulesES, ca: modulesCA, it: modulesIT, pt: modulesPT, nl: modulesNL };

export const tFor = (locale) => (key, fallback) => {
  const text = translations[locale]?.[key] || translations.en?.[key] || translations.fr?.[key];
  return text || (typeof fallback === "string" ? fallback : key);
};

const splitParagraphs = (text) => String(text || "").split(/\n{2,}/).map((s) => s.trim()).filter(Boolean);

export const getModuleContent = (moduleId, locale = "fr") => {
  const base = modulesFR[moduleId];
  if (base) {
    const tr = locale !== "fr" ? (TRANSLATED[locale] || modulesEN)?.[moduleId] : null;
    return {
      module_id: moduleId, lang: locale, is_child: !!base.isChild, title: tr?.title || base.title, subtitle: tr?.subtitle || base.subtitle, sources: [],
      chapters: base.chapters.map((ch, i) => {
        const tCh = tr?.chapters?.[i] || {};
        const q = ch.quiz ? { question: tCh.quiz?.question || ch.quiz.question, options: tCh.quiz?.options || ch.quiz.options, correct: ch.quiz.correct, explanation: tCh.quiz?.explanation || ch.quiz.explanation } : null;
        return { title: tCh.title || ch.title, image: ch.image || null, paragraphs: tCh.paragraphs || ch.paragraphs || [], quiz: q ? [q] : [] };
      }),
    };
  }
  const m = getPsychoeducationModules(tFor(locale)).find((x) => x.id === moduleId);
  if (!m) return null;
  return {
    module_id: moduleId, lang: locale, is_child: false, title: m.title, subtitle: m.subtitle || m.description || "", sources: m.sources || [],
    chapters: [
      ...m.sections.map((s, i) => ({ title: s.title, image: i === 0 && /^https?:/.test(m.sectionImage || "") ? m.sectionImage : null, paragraphs: splitParagraphs(s.content), quiz: [] })),
      ...(m.quiz?.length ? [{ title: tFor(locale)("psychoeducation.quizTitle", "Quiz"), image: null, paragraphs: [], quiz: m.quiz }] : []),
    ],
  };
};

export const fetchModulePdf = async (moduleId, locale, patientName = "") => {
  const content = getModuleContent(moduleId, locale);
  if (!content) throw new Error("Module inconnu");
  const r = await axios.post(`${API}/psychoeducation/pdf`, { module_id: moduleId, lang: locale, patient_name: patientName, content }, { withCredentials: true, responseType: "blob" });
  return new Blob([r.data], { type: "application/pdf" });
};

export const downloadModulePdf = async (moduleId, locale, patientName = "") => {
  const blob = await fetchModulePdf(moduleId, locale, patientName);
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `module-${moduleId}-${locale}.pdf`;
  link.click();
  URL.revokeObjectURL(link.href);
};
